import { render, staticRenderFns } from "./input-block-new.html?vue&type=template&id=342889cf&scoped=true&"
import script from "./input-block-new.js?vue&type=script&lang=js&"
export * from "./input-block-new.js?vue&type=script&lang=js&"
import style0 from "./input-block-new.scss?vue&type=style&index=0&id=342889cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342889cf",
  null
  
)

export default component.exports